import gql from 'graphql-tag'

const getObjectModelQuery = `query ($id: Guid) {
  objectModelQuery {
    draftObjectModel(id: $id)  {
      id, name, content, isSystem, isDraft
    }
  }
}`
export async function getDataContract(schema, id, gqClient) {
  const data = await getData(schema, getObjectModelQuery, id, gqClient)
  if (!data.objectModelQuery && !data.objectModelQuery.draftObjectModel) {
    return ''
  }
  let model = data.objectModelQuery.draftObjectModel
  if (!model.content) {
    return ''
  }
  return getBOIdFromObjectModel(model.content)
}
// Получение данных по запросу
async function getData(schema, query, id, getClient) {
  try {
    const client = await getClient(schema)
    let data = await client.query({
      query: gql`${query}`,
      variables: { id: id }
    })
    return data.data
  } catch (e) {
    throw new Error(e.message)
  }
}
function getBOIdFromObjectModel(content) {
  let domParser = new DOMParser()
  let dom = domParser.parseFromString(content , 'application/xml')
  let objects = dom.getElementsByTagName('bo:object')
  let foundObject = undefined
  for (let index = 0; index < objects.length; index++) {
    if (!objects[index].getElementsByTagName('bpmn:incoming').length) {
      foundObject = objects[index]
    }
  }

  if (!foundObject) {
    return
  }

  return foundObject.getAttribute('businessObjectCode')
}
